import * as cons from './constants';
import { requestReducerMaker, initialState } from '../helper'

export const getAllApplication = (state = initialState, action) => requestReducerMaker(cons.GET_ALL_APPLICATION, state, action);
export const getApplication = (state = initialState, action) => requestReducerMaker(cons.GET_APPLICATION, state, action);
export const createApplication = (state = initialState, action) => requestReducerMaker(cons.CREATE_APPLICATION, state, action);